import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12" data-testid="subscription-cancel">
      <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-xl rounded-2xl border-t-4 border-red-500 p-8 text-center">
          <XCircle className="w-20 h-20 text-red-500 mx-auto mb-6" />
          
          <h1 
            className="text-3xl font-bold text-[#004E86] mb-4"
            style={{fontFamily: 'Barlow Condensed, sans-serif'}}
          >
            Payment Cancelled
          </h1>
          
          <p className="text-lg text-gray-700 mb-6">
            Your subscription payment was cancelled. No charges were made to your account.
          </p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-blue-800 font-medium">Still interested?</p>
            <p className="text-blue-700 text-sm mt-2">
              You can complete your subscription anytime to start capturing RV leads.
            </p>
          </div>
          
          <div className="space-y-3">
            <Button
              onClick={() => navigate('/dealer/register')}
              className="w-full bg-[#F2A900] text-black hover:bg-[#D99700] font-bold uppercase tracking-wide py-3"
              data-testid="try-again"
            >
              Try Again
            </Button>
            
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="w-full"
              data-testid="go-home"
            >
              Return Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
